import {ToothConfigurationModel} from '../../../../models/teeth/tooth-configuration.model';

export class ToothUiManagerModel {
  isSelected: boolean;
  toothModel: ToothConfigurationModel;
  selectedSurfaceIds: string[] = [];

  constructor(isSelected: boolean = null, toothModel: ToothConfigurationModel = null) {
    if (isSelected) {
      this.isSelected = isSelected;
    }

    if (toothModel) {
      this.toothModel = toothModel;
    }
  }
}
